<template>
    <div class="main">
        <el-dialog
            title="人员信息"
            :visible.sync="openData.personState"
            width="60%"
            class="dialog_container"
            @close="handleClose"
        >
            <div class="dialog_content">
                <el-form
                    :inline="true"
                    class="demo-form-inline"
                    style="padding-top: 10px; padding-bottom: 10px"
                >
                    <el-form-item label="姓名:">
                        <el-input
                            v-model="customerName"
                            placeholder="请输入姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="手机号:" style="margin-left: 30px">
                        <el-input
                            v-model="phone"
                            placeholder="请输入手机号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button type="primary" @click="searchData"
                            >查询</el-button
                        >
                        <el-button
                            type="info"
                            icon="el-icon-delete"
                            @click="clearData"
                            >清除条件</el-button
                        >
                    </el-form-item>
                </el-form>
                <el-table
                    :data="tableData"
                    ref="multiapleTable"
                    @selection-change="handleSelectionChange"
                    :row-key="getRowKey"
                    tooltip-effect="dark"
                    style="width: 100%"
                    :header-cell-style="{
                        background: '#e6e6e6',
                        color: '#000',
                    }"
                    border
                >
                    <el-table-column
                        type="selection"
                        width="55"
                        label="选择"
                        align="center"
                        :reserve-selection="true"
                    >
                        <!-- <template slot-scope="scope">
              <el-radio
                :label="scope.row"
                v-model="radioId"
                change="rowClick(scope.row.id)"
                >&nbsp;</el-radio
              >
            </template> -->
                    </el-table-column>
                    <el-table-column
                        type="index"
                        width="70"
                        label="序号"
                        align="center"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="customerName"
                        label="姓名"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        label="性别"
                        :show-overflow-tooltip="true"
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.gender == 0">男</span>
                            <span v-if="scope.row.gender == 1">女</span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        align="center"
                        prop="age"
                        label="年龄"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="phone"
                        label="手机号"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                    <el-table-column
                        align="center"
                        prop="idCard"
                        label="身份证号"
                        :show-overflow-tooltip="true"
                    ></el-table-column>
                </el-table>
                <div class="pagination_container">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="currentPage"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="10"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveRY">确 定</el-button>
                <el-button @click="handleClose">取 消</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
export default {
    props: ["openData", "communityWorkerList"],
    data() {
        return {
            tableData: [],
            customerName: "",
            phone: "",
            total: 0,
            pageSize: 10,
            pageNo: 1,
            radioId: "",
            info: {},
            pageSize: 10,
            pageNo: 1,
            currentPage: 1, //默认展示第一页
            total: 0,
            multipleSelection: [],
        }
    },
    created() {
        this.getList()
    },
    methods: {
        //  保存状态
        getRowKey(row) {
            return row.id
        },
        // 获取内容
        rowClick(row) {
            console.log(row)
            this.info = {}
        },
        // 查询条件
        searchData() {
            this.getList()
        },
        //清除按钮
        clearData() {
            ;(this.customerName = ""), (this.phone = ""), this.getList()
        },
        // 选择 select
        handleSelectionChange(val) {
            console.log(val)
            this.multipleSelection = val
        },
        //传值给父组件
        saveRY() {
            if (this.multipleSelection.length != 0) {
                this.$emit("cancleOpen", this.multipleSelection)
            } else {
                this.multipleSelection = []
            }
            console.log(this.multipleSelection)
            // this.$emit("cancleOpen", this.multipleSelection)
        },
        // 获取列表
        getList() {
            let params = {
                customerName: this.customerName,
                phone: this.phone,
                pageNo: this.pageNo,
                pageSize: this.pageSize,
            }
            this.$http
                .request({
                    url: "/ypt/admin/all/customer/info/findList",
                    method: "POST",
                    data: params,
                })
                .then(async (res) => {
                    console.log(res)
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.total = res.content.count
                        console.log(
                            this.communityWorkerList,
                            "communityWorkerList"
                        )
                        this.$nextTick(() => {
                            this.tableData.forEach((item) => {
                                this.communityWorkerList.forEach((ject) => {
                                    // console.log(ject.id);
                                    // console.log(item.id);
                                    if (ject.id == item.id) {
                                        console.log("==")
                                        this.$refs[
                                            "multiapleTable"
                                        ].toggleRowSelection(item, true)
                                    }
                                })
                            })
                        })
                    } else {
                        this.$message.error(res.message)
                    }
                })
        },
        // 分页
        handleSizeChange(val) {
            this.pageSize = val
            this.getList()
        },
        handleCurrentChange(val) {
            this.pageNo = val
            this.getList()
        },
        // 关闭
        handleClose() {
            this.$emit("cancleOpen", "")
        },
    },
}
</script>
<style lang="less" scoped>
.footer {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 15px;
}
</style>
  